export default __webpack_public_path__ + "img/4-67575ffc.png";